import { format, parseISO } from 'date-fns';
import pt from 'date-fns/locale/pt';

export default function formatToYear(date) {
  if (!(date instanceof Date)) {
    return format(parseISO(date), 'yy', {
      locale: pt,
    });
  }

  return format(date, 'yy', {
    locale: pt,
  });
}